import { PaginationParams } from "@/interfaces/api.interface";

type EntityName =
  | "projects"
  | "userProjects"
  | "levels"
  | "lookups"
  | "company"
  | "request"
  | "tasks"
  | "users"
  | "notifications"
  | "logs"
  | "levelHistory"
  | "userGroup";

function createEntityQueryKeys(entityName: EntityName) {
  return {
    root: [entityName] as const,
    all: (params?: PaginationParams) => [entityName, "all", params] as const,
    list: (params?: PaginationParams) => [entityName, "list", params] as const,
    detail: (id: string) => [entityName, "detail", id] as const,
  };
}

export const queryKeys = {
  projects: createEntityQueryKeys("projects"),
  userProjects: createEntityQueryKeys("userProjects"),
  levels: {
    ...createEntityQueryKeys("levels"),
    export: (params?: PaginationParams) => ["levels", "export", params],
    areas: (id: string, version: number, userId?: string, levelId?: string) => [
      "levels",
      "areas",
      userId,
      levelId,
      version,
    ],
    distinctActiveNames: (projectId: string) => ["levels", "distinct-active-names", projectId] as const,
  },
  lookups: createEntityQueryKeys("lookups"),
  company: {
    ...createEntityQueryKeys("company"),
    users: (projectId: string) => ["company", "users", projectId] as const,
  },
  request: createEntityQueryKeys("request"),
  tasks: {
    ...createEntityQueryKeys("tasks"),
    request: (requestId: string) => ["tasks", "request", requestId] as const,
  },
  users: createEntityQueryKeys("users"),
  notifications: createEntityQueryKeys("notifications"),
  logs: createEntityQueryKeys("logs"),
  levelHistory: createEntityQueryKeys("levelHistory"),
  userGroup: {
    ...createEntityQueryKeys("userGroup"),
    withCompanyInfo: (projectId: string, levelId: string) => 
      ["userGroup", "withCompanyInfo", projectId, levelId] as const,
  },
} as const;
